import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import BreadCrumb from '../componets/breadcrumb';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

// Terms and Conditions JSON files
import enTermsConditions from "../../locales/en/termsAndConditions.json";
import esTermsConditions from "../../locales/es/termsAndConditions.json";

// title 
import esTitle from "../../locales/es/title.json";
import enTitle from "../../locales/en/title.json";

export default function TermsAndConditions() {
  const Languages = useSelector((state) => state.auth.lang);
  const [termsContent, setTermsContent] = useState(enTermsConditions);
  const [title, setTitle] = useState(enTitle);

  useEffect(() => {
    // Update content when language changes
    setTermsContent(Languages === 'es' ? esTermsConditions : enTermsConditions);
    setTitle(Languages === 'es' ? esTitle : enTitle);
  }, [Languages]);

  const { termsAndConditions } = termsContent;

  const renderSection = (section) => {
    switch (section.type) {
      case 'list':
        return (
          <ul className="list-disc ml-5 space-y-2">
            {section.items?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        );
      
      case 'paragraph':
        return (
          <p>
            {section.content}
            {section.linkText && section.linkUrl && (
              <>
                {' '}
                <Link href={section.linkUrl} className="text-blue-600 underline">
                  {section.linkText}
                </Link>
                {' for details.'}
              </>
            )}
          </p>
        );
      
      case 'contact':
        return (
          <address className="not-italic">
            {termsAndConditions?.contactInfo?.organizationName}<br />
            {termsAndConditions?.contactInfo?.address?.street}<br />
            {termsAndConditions?.contactInfo?.address?.suite}<br />
            {termsAndConditions?.contactInfo?.address?.city}, {termsAndConditions?.contactInfo?.address?.state} {termsAndConditions?.contactInfo?.address?.zipCode}<br />
            <a 
              href={`mailto:${termsAndConditions?.contactInfo?.email}`} 
              className="text-blue-600 underline"
            >
              {termsAndConditions?.contactInfo?.email}
            </a><br />
            <a 
              href={`tel:${termsAndConditions?.contactInfo?.phoneHref}`} 
              className="text-blue-600 underline"
            >
              {termsAndConditions?.contactInfo?.phone}
            </a>
          </address>
        );
      
      default:
        return <p>{section.content}</p>;
    }
  };

  return (
    <div >

      <BreadCrumb
        PageName={termsAndConditions?.title}
        PartentPage={title?.Home?.title}
        PartentURL="/"
        ChildName=""
        ChildURL=""
        CurrentPage={termsAndConditions?.title}
      />

      <div className="container mx-auto px-4 py-10 mt-5">
        <main className="max-w-5xl mx-auto px-4 py-10">
          {/* Header Section */}
          <section className="mb-5 p-0">
            <h1 className="text-4xl font-bold mb-6">{termsAndConditions?.title}</h1>
            <p>{termsAndConditions?.introduction}</p>
          </section>

          {/* Dynamic Sections */}
          {termsAndConditions?.sections?.map((section, index) => (
            <section key={section.id || index} className="mb-5 p-0">
              <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
              {renderSection(section)}
            </section>
          ))}
        </main>
      </div>
    </div>
  );
}